import React from 'react';
import { isNil } from 'lodash';
import LabelInfo from '../../../../../components/LabelInfo';
import InfoTable from '../../../../../components/table/InfoTable';
import OpenProductDetail from '../../../../../components/link/OpenProductDetail';
import OpenPreviewProductDetail from '../../../../../containers/app/common/OpenPreviewProductDetail';
import OpenBrandDetail from '../../../../../components/link/OpenBrandDetail';
import Anchor from '../../../../../components/link/Anchor';
import { DISCOUNT_TYPE_TEXT } from '../../../../../constants/service/app/productConstants';
import { PRODUCT_STATUS_TEXT } from '../../../../../constants/service/app/productConstants';
import { setDash, setNumberWithComma } from '../../../../../lib/common';
import TableColumnImg from '../../../../../components/table/TableColumnImg';
import { useAccountUserCartDetail, useAccountUserDetailCartLogModal } from './hooks';
import AccountUserDetailCartLogModal from '../common/modal/AccountUserDetailCartLogModal';
import './AccountUserDetailCartInfo.scss';

const AccountUserDetailCartInfo = (props) => {
  const { userId } = props;

  const {
    isModalOpen,
    openAddCartLogModal,
    openRemoveCartLogModal,
    userCartLogList,
    closeModal,
    filterOption,
    sortOption,
    getList,
  } = useAccountUserDetailCartLogModal({ userId });

  const { cartSummaryData, cartHistoryList } = useAccountUserCartDetail({ userId });
  const { totalPrice, addToCartAmount, quantity, removeToCartAmount } = cartSummaryData;

  return (
    <div className="account-user-detail-content account-user-detail-cart-info-content">
      <div className="account-user-detail-section">
        <div className="title">장바구니 정보</div>

        <div className="account-user-detail-section-content">
          <div className="form-wrap">
            <LabelInfo label="총 결제 금액" info={`₩ ${setNumberWithComma(totalPrice)}`} />

            <LabelInfo
              label="총 장바구니 추가 수"
              info={<Anchor text={addToCartAmount} isUnderLine color="primary" onClick={openAddCartLogModal} />}
            />
          </div>

          <div className="form-wrap">
            <LabelInfo label="상품 수량" info={quantity} />

            <LabelInfo
              label="총 장바구니 삭제 수"
              info={<Anchor text={removeToCartAmount} isUnderLine color="primary" onClick={openRemoveCartLogModal} />}
            />
          </div>

          <div className="form-wrap">
            <LabelInfo
              label="A.point 예상 적립"
              info={<span className="primary">{`+ ${setNumberWithComma(cartSummaryData.totalPrice / 100)}p`}</span>}
            />
          </div>
        </div>

        <div className="cart-list-content">
          <div className="title">장바구니 리스트</div>

          <div className="cart-list">
            <InfoTable>
              <thead>
                <tr>
                  <th>브랜드 ID</th>
                  <th>브랜드명</th>
                  <th>상품 이미지</th>
                  <th>상품 ID</th>
                  <th>상품명</th>
                  <th>상품 상태</th>
                  <th>판매가(원)</th>
                  <th>할인가(원)</th>
                  <th>할인율</th>
                  <th>할인 설정</th>
                  <th>할인 기간</th>
                  <th>옵션</th>
                  <th>옵션가</th>
                  <th>실 판매가</th>
                  <th>수량</th>
                  <th>총 결제 금액</th>
                </tr>
              </thead>
              <tbody>
                {cartHistoryList.map((item, index) => (
                  <tr key={item.id}>
                    {item.storeId && (
                      <td className="tc" rowSpan={item.storeRowSpan ? item.storeRowSpan : 1}>
                        <OpenBrandDetail text={item.storeId} storeId={item.storeId} />
                      </td>
                    )}
                    {item.storeName && (
                      <td className="tc" rowSpan={item.storeRowSpan ? item.storeRowSpan : 1}>
                        <OpenBrandDetail text={item.storeName} storeId={item.storeId} />
                      </td>
                    )}
                    {item.url && (
                      <td className="tc" rowSpan={item.productRowSpan ? item.productRowSpan : 1}>
                        <TableColumnImg url={item.url} />
                      </td>
                    )}
                    {item.productId && (
                      <td className="tc" rowSpan={item.productRowSpan ? item.productRowSpan : 1}>
                        <OpenProductDetail text={item.productId} productId={item.productId} />
                      </td>
                    )}
                    {item.productName && (
                      <td className="tc" rowSpan={item.productRowSpan ? item.productRowSpan : 1}>
                        <OpenPreviewProductDetail text={item.productName} productId={item.productId} />
                      </td>
                    )}
                    {item.productStatus && (
                      <td className="tc" rowSpan={item.productRowSpan ? item.productRowSpan : 1}>
                        {PRODUCT_STATUS_TEXT[item.productStatus]}
                      </td>
                    )}
                    {item.originPrice && (
                      <td className="tc" rowSpan={item.productRowSpan ? item.productRowSpan : 1}>
                        {setNumberWithComma(item.originPrice)}
                      </td>
                    )}
                    {item.salesPrice && (
                      <td className="tc" rowSpan={item.productRowSpan ? item.productRowSpan : 1}>
                        {setNumberWithComma(item.salesPrice)}
                      </td>
                    )}
                    {(item.productId || item.discountRate) && (
                      <td className="tc discountRate" rowSpan={item.productRowSpan ? item.productRowSpan : 1}>
                        {setDash(item.discountRate)}
                      </td>
                    )}
                    {(item.productId || !isNil(item.discountType)) && (
                      <td className="tc discountType" rowSpan={item.productRowSpan ? item.productRowSpan : 1}>
                        {setDash(DISCOUNT_TYPE_TEXT[item.discountType])}
                      </td>
                    )}
                    {(item.productId || item.discount) && (
                      <td className="tc discount" rowSpan={item.productRowSpan ? item.productRowSpan : 1}>
                        {item.discount}
                      </td>
                    )}
                    <td className="tc">{setDash(item.productOption)}</td>
                    <td className="tc">{setNumberWithComma(item.productOptionPrice)}</td>
                    <td className="tc">{setNumberWithComma(item.actualPrice)}</td>
                    <td className="tc addToCartAmount">{item.addToCartAmount}</td>
                    {!index && (
                      <td className="tc" rowSpan={cartHistoryList.length}>
                        {setNumberWithComma(cartSummaryData.totalPrice)}
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </InfoTable>
          </div>
        </div>
      </div>
      {isModalOpen && (
        <AccountUserDetailCartLogModal
          isOpen={isModalOpen}
          closeModal={closeModal}
          list={userCartLogList}
          filterOption={filterOption}
          sortOption={sortOption}
          getList={getList}
        />
      )}
    </div>
  );
};

export default AccountUserDetailCartInfo;
